const SET_LIST = (state, obj) => {
  state.list = obj
}

const SET_DADOS_BASICOS = (state, obj) => {
  state.dadosBasicos = obj
}

const SET_DESCRICAO = (state, obj) => {
  state.descricao = obj
}

const SET_LINGUA_TO_LIST = (state, obj) => {
  state.linguaList.push(obj)
}

const SET_LINGUA_LIST = (state, obj) => {
  state.linguaList = obj
}

const SET_HABILIDADE_TO_LIST = (state, obj) => {
  state.habilidadeList.push(obj)
}

const SET_HABILIDADE_LIST = (state, obj) => {
  state.habilidadeList = obj
}

const SET_CERTIFICACAO_TO_LIST = (state, obj) => {
  state.certificacaoList.push(obj)
}

const SET_CERTIFICACAO_LIST = (state, obj) => {
  state.certificacaoList = obj
}

const SET_FORMACAO_ACADEMICA_TO_LIST = (state, obj) => {
  state.formacaoAcademicaList.push(obj)
}

const UPDATE_FORMACAO_ACADEMICA_TO_LIST = (state, obj) => {
  state.formacaoAcademicaList[obj.index] = obj.value
}

const REMOVE_FORMACAO_ACADEMICA_FROM_LIST = (state, index) => {
  state.formacaoAcademicaList.splice(index, 1)
}

const SET_FORMACAO_ACADEMICA_LIST = (state, obj) => {
  state.formacaoAcademicaList = obj
}

const UPDATE_HISTORICO_PROFISSIONAL_TO_LIST = (state, obj) => {
  state.historicoProfissionalList[obj.index] = obj.value
}

const REMOVE_HISTORICO_PROFISSIONAL_FROM_LIST = (state, index) => {
  state.historicoProfissionalList.splice(index, 1)
}

const SET_HISTORICO_PROFISSIONAL_TO_LIST = (state, obj) => {
  state.historicoProfissionalList.push(obj)
}

const SET_HISTORICO_PROFISSIONAL_LIST = (state, obj) => {
  state.historicoProfissionalList = obj
}

const SET_TIPO_EMPRESA = (state, obj) => {
  state.tipoEmpresa = obj
}

const SET_RAMO_ATIVIDADE = (state, obj) => {
  state.ramoAtividade = obj
}

const SET_CATEGORIA = (state, obj) => {
  state.categoria = obj
}

const SET_CATEGORIA_TO_LIST = (state, obj) => {
  state.categoriaList.push(obj)
}

const SET_CATEGORIA_LIST = (state, obj) => {
  state.categoriaList = obj
}

const SET_VPUSER = (state, obj) => {
  state[obj.state].idUsuario = obj.value
}

const SET_VALIDATION = (state, obj) => {
  state[obj.state] = obj.value
}

export default {
  SET_LIST,
  SET_VPUSER,
  SET_VALIDATION,
  SET_DADOS_BASICOS,
  SET_DESCRICAO,
  SET_LINGUA_TO_LIST,
  SET_LINGUA_LIST,
  SET_HABILIDADE_TO_LIST,
  SET_HABILIDADE_LIST,
  SET_CERTIFICACAO_TO_LIST,
  SET_CERTIFICACAO_LIST,
  SET_FORMACAO_ACADEMICA_TO_LIST,
  UPDATE_FORMACAO_ACADEMICA_TO_LIST,
  REMOVE_FORMACAO_ACADEMICA_FROM_LIST,
  SET_FORMACAO_ACADEMICA_LIST,
  SET_HISTORICO_PROFISSIONAL_TO_LIST,
  UPDATE_HISTORICO_PROFISSIONAL_TO_LIST,
  REMOVE_HISTORICO_PROFISSIONAL_FROM_LIST,
  SET_HISTORICO_PROFISSIONAL_LIST,
  SET_TIPO_EMPRESA,
  SET_RAMO_ATIVIDADE,
  SET_CATEGORIA_LIST,
  SET_CATEGORIA_TO_LIST,
  SET_CATEGORIA
}



// WEBPACK FOOTER //
// ./src/features/vp/curriculo/meusCurriculos/store/mutations.js